import { useCurrentUser } from '@hooks/useCurrentUser'
import { FC } from 'react'
import { BasicNavPromotion } from '@components/header/Basic'
import { PremiumNavPromotion } from '@components/header/Premium'

export const NavigationPromotion: FC = () => {
    const currentUser = useCurrentUser().data

    if (!currentUser) {
        return null
    }

    const { isPremium } = currentUser

    if (isPremium) {
        return <PremiumNavPromotion />
    }

    return <BasicNavPromotion />
}
